import { Table } from 'antd';
import { BankOutlined, ScissorOutlined, TeamOutlined } from '@ant-design/icons';
import PhaseShell, { SectionCard, StatChip } from '../../../components/registry/PhaseShell';
import type { PhasePageProps } from '../../../components/registry/RegistryPhaseWorkspace';
import {
  RegistryEncounterTable,
  SectionEmpty,
  groupBySourceDocument,
  registryDate as date,
  renderDocGroups,
} from '../../../components/registry/registryDocGroups';
import { allSurgeries } from './phases';

/** Faza 3 — Tratament & Chirurgie Plastică: intervenții, consulturi oncologice, internări. */
export default function Faza3Page({ record, status }: PhasePageProps) {
  const surgeries = allSurgeries(record);
  const oncologyConsults = record.encounters.filter((e) => e.type === 'ONCOLOGY_CONSULT');
  const hospitalizations = record.encounters.filter(
    (e) => e.type === 'HOSPITALIZATION' || e.type === 'OBSERVATION',
  );

  return (
    <PhaseShell
      title="Faza 3 — Tratament & Chirurgie Plastică"
      description="Decizia comisiei multidisciplinare și tratamentul/chirurgia plastică a pacientului."
      status={status}
      chips={
        <>
          <StatChip count={surgeries.length} label="intervenții" />
          <StatChip count={oncologyConsults.length} label="consulturi oncologice" />
          <StatChip count={hospitalizations.length} label="internări" />
        </>
      }
    >
      <SectionCard icon={<ScissorOutlined />} title="Intervenții chirurgicale">
        {surgeries.length === 0 && oncologyConsults.length === 0 ? (
          <SectionEmpty />
        ) : (
          <>
            {surgeries.length > 0 &&
              renderDocGroups(
                groupBySourceDocument(surgeries, record.documents, (s) => s.sourceDocumentId),
                (items) => (
                  <Table
                    size="small"
                    rowKey={(s) => `${s.caseCode}-${s.date}-${s.procedureType}`}
                    pagination={false}
                    style={{ marginBottom: 16 }}
                    dataSource={items}
                    columns={[
                      { title: 'Caz', dataIndex: 'caseCode', key: 'c' },
                      { title: 'Data', dataIndex: 'date', key: 'd', render: (v: string | null) => date(v) },
                      { title: 'Tip procedură', dataIndex: 'procedureType', key: 't', render: (v: string | null) => v ?? '—' },
                      { title: 'Note', dataIndex: 'notes', key: 'n', render: (v: string | null) => v ?? '—' },
                    ]}
                  />
                ),
              )}
            {oncologyConsults.length > 0 && (
              <>
                <div style={{ fontWeight: 600, margin: '8px 0 4px' }}>
                  <TeamOutlined /> Consulturi oncologice
                </div>
                {renderDocGroups(
                  groupBySourceDocument(oncologyConsults, record.documents, (e) => e.sourceDocumentId),
                  (items) => <RegistryEncounterTable encounters={items} />,
                )}
              </>
            )}
          </>
        )}
      </SectionCard>

      <SectionCard icon={<BankOutlined />} title="Internări și proceduri">
        {hospitalizations.length === 0 ? (
          <SectionEmpty />
        ) : (
          renderDocGroups(
            groupBySourceDocument(hospitalizations, record.documents, (e) => e.sourceDocumentId),
            (items) => <RegistryEncounterTable encounters={items} showProcedures />,
          )
        )}
      </SectionCard>
    </PhaseShell>
  );
}
